/*************************
 * Author : Matthieu ROBIN
 *************************/
import React, { FunctionComponent } from "react";
import { useParams } from "react-router";
import CarForm from "../components/CarForm";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { useAppSelector } from "../app/hooks";
import { selectCar } from "../slices/cars-slice";

const CarEditPage: FunctionComponent = () => {
  const theme = useTheme();
  const params = useParams();
  const car = useAppSelector(selectCar(params.id));
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    car && (
      <Dialog
        open={true}
        maxWidth="md"
        fullWidth
        fullScreen={fullScreen}
        scroll="body"
      >
        <CarForm car={car} />
      </Dialog>
    )
  );
};

export default CarEditPage;
